import { useQuery } from '@apollo/client';
import { GET_COUNTRIES } from '../api/dictionaries';
import { QueryListResponse, SelectOption } from 'global';

import { DealSheetAPINameSpase } from '../../dealSheet/types';

export const useCountries = () => {
  const { data, loading } = useQuery<DealSheetAPINameSpase<QueryListResponse<SelectOption>>>(GET_COUNTRIES);

  return {
    loading,
    countries: data?.dealSheet?.result?.list ?? [],
  };
};
